import type { SnackbarContextType } from '@/contexts/SnackbarContext.types';

/**
 * Handles API errors and displays them in UI using snackbars
 * Uses formatted thrown error and renders it UI
 *
 * @param error - unknown
 * @param snackbar - The snackbar context to show error messages
 * @param defaultMessage - Default message to show if error cannot be parsed
 * @returns Promise that resolves to the error data
 */
export function handleSnackbarError(error: unknown, snackbar: SnackbarContextType, defaultMessage: string = 'An error occurred'): void {
  let errorMessage = defaultMessage;

  if (error instanceof Error) {
    const trimmedMessage = error.message.trim();

    if (trimmedMessage && trimmedMessage !== 'false') {
      errorMessage = trimmedMessage.length < 15 ? `${trimmedMessage} ${defaultMessage}`.trim() : trimmedMessage;
    }
  }

  snackbar.showError(errorMessage);
}
